// Lead sold state (spec A2). "won" comes only from the funded deal: the
// backend markFundedDealSales job stamps sold_deal_id + sold_source
// 'funded_deal'. A manual write of won/sold is reverted server-side, so the
// UI never offers it and shows the sold state read-only.

import constants from './constants';

export const CAR_SOLD_OTHER_BUYER = 'car sold - other buyer';

export const isSystemSoldStatus = (status) =>
  ['won', 'sold'].includes(String(status || '').trim().toLowerCase());

// A lead counts as won only by its status. A stale won_deal on a lead that
// moved on (e.g. 'car sold - other buyer') does not make it a win.
export const isWonLead = (lead) => isSystemSoldStatus(lead?.status);

// Status pickers: never won/sold. `current` is dropped from the list when given.
export const manualStatusOptions = (current) =>
  constants.manual_lead_statuses.filter((status) => status !== current);

// A sold lead's status cannot be changed by hand.
export const isStatusLocked = (lead) => isSystemSoldStatus(lead?.status);

export const statusLabel = (status) => {
  const s = String(status || 'pending contact');
  if (isSystemSoldStatus(s)) return 'Sold';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

// Read-only caption for a sold lead, e.g. "Sold · deal SN3028".
export const soldCaption = (lead) => {
  const deal = lead?.sold_deal_id || lead?.won_deal;
  return deal ? `Sold · deal ${deal}` : 'Sold';
};

export const LOCKED_STATUS_MESSAGE = 'Sold is set when the car\'s deal funds. It cannot be changed here.';
